export default {
    PENDENTE: 0,
    NOTA_EMITIDA: 1,
    EM_TRANSPORTE: 2,
    ENTREGUE: 3,
    CANCELADO: 4,
    MENSAGEM: 5,
    ENVIADO_SEPARACAO: 6,
    AGUARDANDO_TRANSPORTADORA: 7,
    RECOLHIDO_TRANSPORTADORA: 8,
    EXTRAVIADO: 8,

    /*
- Enviado para separação
- Aguardando Retirada da Transportadora
- Recolhido pela Transportadora
    */

    desc: (value) => {
        switch(value){
            case 0:
                return 'Pendente';

            case 1:
                return 'Nota fiscal emitida';
            
            case 2:
                return 'Enviado';

            case 3:
                return 'Entregue';

            case 4:
                return 'Cancelado';

            case 5:
                return 'Mensagem';

            case 6:
                return 'Enviado para separação';

            case 7: 
                return 'Aguardando Retirada da Transportadora';

            case 8:
                return 'Recolhido pela Transportadora';
            
            case 9:
                return 'Extraviado';

            default: return value.toString();

        }
    }
}